import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/svg/arrow-right-circle-blue-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-3ee120c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "gallery-block" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "gallery" }
const _hoisted_5 = { class: "show-more-cases-wrapper wow-total animate__fadeInUp" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "circled-blue-arrow",
  src: _imports_0,
  alt: "show more icon"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppGalleryEl = _resolveComponent("AppGalleryEl")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppGalleryModal = _resolveComponent("AppGalleryModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", {
          class: "title wow-total animate__fadeInUp",
          innerHTML: _ctx.pageData['galleryTitle']
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageData['galleryList'], (el, index) => {
            return (_openBlock(), _createBlock(_component_AppGalleryEl, {
              key: el['ID'],
              elementData: el['acf'],
              onClick: ($event: any) => (_ctx.galleryModal(true, index, el['acf']['galleryListProductHash']))
            }, null, 8, ["elementData", "onClick"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/portfolio",
            class: "btn show-more-cases"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.pageData['galleryButtonText']), 1),
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        (_ctx.galleryModalActive)
          ? (_openBlock(), _createBlock(_component_AppGalleryModal, {
              key: 0,
              onGalleryModal: _ctx.galleryModal,
              modalData: _ctx.pageData['galleryList'][_ctx.currentIndex]['acf'],
              pageData: _ctx.pageData
            }, null, 8, ["onGalleryModal", "modalData", "pageData"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}